module.exports = __webpack_public_path__ + "images/柏纳长图_06-1.jpg?v=2998550a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_06-1.jpg
 ** module id = 145
 ** module chunks = 1 2
 **/